export const ROUTES = {
  PUBLIC: {
    NOT_FOUND: '/404',
  },
  AUTHORIZED: {
    LANDING: '/',
    HELP: '/help',
    TEST_PAGE: '/test',
    CALENDAR: '/calendar',
    NOTIFICATIONS: '/notifications',
    ADVERTISING_SPACES: '/advertising-spaces',
    COMPANY_PROFILE: '/company-profile',
    COMPANY_LOCATIONS: '/company-locations',
    USER_PROFILE: '/user-profile',
    PROFILE_FORM: '/user-profile/edit',
    ORDERS: '/orders',
    SERVICE_ORDERS: '/service/orders',
    FINANCIAL: '/financial',
    COMPANY_FORM: '/company-form',
    COMPANY_LOCATION_FORM: '/company-location-form',
    COMPANY_CLIENT_FORM: '/company-client/form',
    COMPANY_TEAM_MEMBER_FORM: '/company-team-member',
    DELETE_COMPANY_CLIENT: '/company-client/remove',
    DELETE_COMPANY_TEAM_MEMBER: '/company-team-member/remove',
    INVITE_SUCCESSFUL: '/team-member-invited',
    MEDIA_PLANS: '/media-plans',
    MEDIA_PLAN_FORM: '/media-plans/edit',
    MEDIA_PLAN_ORDERED: '/media-plans/ordered',
    DELETE_MEDIA_PLAN: '/media-plans/remove',
    DELETE_ORDER: '/orders/remove',
    REJECT_ORDER: '/orders/reject',
    ADVERTISING_SPACE_FORM: '/advertising-spaces/edit',
    DELETE_ADVERTISING_SPACE: '/advertising-spaces/delete',
    ADVERTISING_PACKAGES: '/advertising-packages',
    ADVERTISING_PACKAGES_FORM: '/advertising-packages/edit',
    ADVERTISING_PACKAGES_DELETE: '/advertising-packages/delete',
    STATISTICS: '/statistics',
    STATISTICS_MOCK: '/statistics-mock',
    QUOTES: '/quotes',
    REBATE_POLICY_FORM: '/rebate-policy',
    SERVICES: '/services',
    SERVICE_FORM: '/services/edit',
    DELETE_SERVICE: '/services/delete',
    ADMIN_SIGNUP_REQUESTS: '/admin/signup-requests',
    ADMIN_USERS: '/admin/users',
    DELETE_ADMIN_USERS: '/admin/users/delete',
    ADMIN_SERVICES: '/admin/services',
    ADMIN_SETTINGS: '/admin/settings',
    LOCATION_PLAN: '/location-plan',
    LOCATION_REPORTS: '/location-reports',
    ONBOARDING: '/onboarding',
    CAMPAIGN_WIZARD: '/campaign-wizard',
    SERVICE_SUPPLIERS: '/service-suppliers',
    GENERATIK_TABLE_DEMO: '/generatik-table-demo',
    GENERATIK_ORDERS_DEMO: '/generatik-orders-demo',
    CAMPAIGN_OVERVIEW: '/campaign-overview',
    ASSISTANT: '/assistant',
  },
} as const;
